import { createFileRoute } from "@tanstack/react-router"

import { useAuthStore } from "@/stores/authStore"

export const Route = createFileRoute("/logout")({
  beforeLoad: async () => {
    const store = useAuthStore.getState()
    await store.clearAuth()
    location.assign("/")
  },
  component: () => null,
})
